import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useAppState } from '@/lib/AppState';
export default function MapSvg({ children, }) {
    const { publicPath } = useAppState();
    const imgSrc = `${publicPath}images/map.svg`;
    return (_jsxs("locator-map-svg", { children: [_jsx("img", { src: imgSrc, alt: "" }), children && (_jsx("locator-map-svg-content", { children: children }))] }));
}
